import { Component } from 'react';
import { connect } from 'react-redux';

import { isEventTicketItemData } from 'common/helpers/featureFlags';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateCartItem } from 'redux/cart/actions';

class Item extends Component {
  constructor(props) {
    super(props);

    this.state = {
      quantity: props.item.quantity
    };
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { state } = this;
    if (newProps.item.quantity !== state.quantity) {
      this.setState({ quantity: newProps.item.quantity });
    }
  }

  submitForm = (e) => {
    e.preventDefault();
    const { item } = this.props;
    const { props, state } = this;
    if (state.quantity === '') {
      props.onError('Invalid Quantity');
    } else {
      const errorFunction = () => {
        this.setState({ quantity: props.item.quantity });
      };
      let useLoyaltyPoints = false;
      if (item.itemData?.useLoyaltyPoints) {
        useLoyaltyPoints = true;
      }
      props.updateCartItem(
        item.sku,
        convertStringToInteger(state.quantity),
        useLoyaltyPoints,
        errorFunction
      );
    }
  };

  handleQuantity = (e) => {
    const { props } = this;
    const input = e.target.value;
    const quantity = input.replace(/[^0-9]/g, '');
    this.setState({ quantity });
    props.onError(null);
  };

  render() {
    const { item, describedby } = this.props;
    const { quantity } = this.state;
    if (isEventTicketItemData(item.type, item.sku)) {
      return <>{item.quantity}</>;
    }
    if (item.type === 'Gift Card' && item?.itemData) {
      return <>{item.quantity}</>;
    }
    return (
      <form action="" onSubmit={this.submitForm} method="post">
        <input
          name="quantity"
          type="text"
          value={quantity}
          onChange={this.handleQuantity}
          inputMode="numeric"
          aria-label={`Quantity for ${item.productTitle}`}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...describedby}
        />
        <br />
        <button type="submit" className="c7-button-alt-small">
          Update
        </button>
      </form>
    );
  }
}

export default connect(null, { updateCartItem })(Item);
